import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/user/profile/profile.component';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';

import { DxButtonModule } from 'devextreme-angular'; 
import { TranslateModule } from '@ngx-translate/core';
import { VoucherComponent } from './pages/voucher/voucher/voucher.component';
import { PickCarComponent } from './pages/voucher/pick-car/pick-car.component';
import { RuleCheckComponent } from './pages/voucher/rule-check/rule-check.component';
import { PickClientComponent } from './pages/voucher/pick-client/pick-client.component';
import { PickRegionComponent } from './pages/voucher/pick-region/pick-region.component';
import { PickRouteComponent } from './pages/voucher/pick-route/pick-route.component';
import { ChecklistComponent } from './pages/voucher/checklist/checklist.component';
import { InputOdometerComponent } from './pages/voucher/input-odometer/input-odometer.component';
import { FinishVoucherComponent } from './pages/voucher/finish-voucher/finish-voucher.component';
import { FuelPurchaseComponent } from './pages/common/fuel-purchase/fuel-purchase.component';
import { ServicePointManagerComponent } from './pages/dio/service-point-manager/service-point-manager.component';
import { NewVisitServicePointComponent } from './pages/dio/new-visit-service-point/new-visit-service-point.component';
import { VisitedServicePointComponent } from './pages/dio/visited-service-point/visited-service-point.component';
import { AdBluePurchaseComponent } from './pages/common/ad-blue-purchase/ad-blue-purchase.component';
import { CarWashPurchaseComponent } from './pages/common/car-wash-purchase/car-wash-purchase.component';
import { CommentComponent } from './pages/common/comment/comment.component';
import { AlcometerValueComponent } from './pages/common/alcometer-value/alcometer-value.component';
import { VisualDamagePickTypeComponent } from './pages/visual-damage/visual-damage-pick-type/visual-damage-pick-type.component';
import { VisualDamageActionPickComponent } from './pages/visual-damage/visual-damage-action-pick/visual-damage-action-pick.component';
import { VisualDamageDeffectPositionPickComponent } from './pages/visual-damage/visual-damage-deffect-position-pick/visual-damage-deffect-position-pick.component';
import { VisualDamagePostDamageComponent } from './pages/visual-damage/visual-damage-post-damage/visual-damage-post-damage.component';
import { MessagesComponent } from './pages/user/messages/messages.component';
import { WavesComponent } from './pages/common/waves/waves.component';
import { ServiceVoucherComponent } from './pages/service/service-voucher/service-voucher.component';
import { ServicePickCarComponent } from './pages/service/service-pick-car/service-pick-car.component';
import { ServiceVoucherStartAddCommentsComponent } from './pages/service/service-voucher-start-add-comments/service-voucher-start-add-comments.component';
import { ServiceVoucherStartPickServiceComponent } from './pages/service/service-voucher-start-pick-service/service-voucher-start-pick-service.component';
import { ServiceVoucherStartOdometerComponent } from './pages/service/service-voucher-start-odometer/service-voucher-start-odometer.component';
import { ServiceManageCarFaultsComponent } from './pages/service/service-manage-car-faults/service-manage-car-faults.component';
import { ServiceVoucherFinishComponent } from './pages/service/service-voucher-finish/service-voucher-finish.component';
import { ContactsComponent } from './pages/user/contacts/contacts.component';
import { StopsComponent } from './pages/common/stops/stops.component';
import { PickTrailerComponent } from './pages/voucher/pick-trailer/pick-trailer.component';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'voucher',
    component: VoucherComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'pick-car',
    component: PickCarComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'rule-check',
    component: RuleCheckComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'pick-client',
    component: PickClientComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'pick-region',
    component: PickRegionComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'pick-route',
    component: PickRouteComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'checklist',
    component: ChecklistComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'input-odometer',
    component: InputOdometerComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'finish-voucher',
    component: FinishVoucherComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'fuel-purchase',
    component: FuelPurchaseComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-fuel-purchase',
    component: FuelPurchaseComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'ad-blue-purchase',
    component: AdBluePurchaseComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-ad-blue-purchase',
    component: AdBluePurchaseComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-point-manager',
    component: ServicePointManagerComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'new-visit-service-point',
    component: NewVisitServicePointComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'visited-service-point/:id',
    component: VisitedServicePointComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'car-wash-purchase',
    component: CarWashPurchaseComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'comment',
    component: CommentComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-comment',
    component: CommentComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'alcometer-value',
    component: AlcometerValueComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-alcometer-value',
    component: AlcometerValueComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'visual-damage-pick-type',
    component: VisualDamagePickTypeComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-visual-damage-pick-type',
    component: VisualDamagePickTypeComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'visual-damage-action-pick',
    component: VisualDamageActionPickComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-visual-damage-action-pick',
    component: VisualDamageActionPickComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'visual-damage-deffect-position-pick',
    component: VisualDamageDeffectPositionPickComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-visual-damage-deffect-position-pick',
    component: VisualDamageDeffectPositionPickComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'visual-damage-post-damage',
    component: VisualDamagePostDamageComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-visual-damage-post-damage',
    component: VisualDamagePostDamageComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'messages',
    component: MessagesComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'waves',
    component: WavesComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-voucher',
    component: ServiceVoucherComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-pick-car',
    component: ServicePickCarComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-voucher-start-add-comments',
    component: ServiceVoucherStartAddCommentsComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-voucher-start-pick-service',
    component: ServiceVoucherStartPickServiceComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-voucher-start-odometer',
    component: ServiceVoucherStartOdometerComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-manage-car-faults',
    component: ServiceManageCarFaultsComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'service-voucher-finish',
    component: ServiceVoucherFinishComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'stops',
    component: StopsComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'pick-trailer',
    component: PickTrailerComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule,
    TranslateModule,
    DxButtonModule
  ],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [
    HomeComponent,
    ProfileComponent
  ]
})
export class AppRoutingModule { }
